export const useGuestplan = (locale) => {
	const route = useRoute();

	const pageSlug = computed(() => useFilename(route, locale.value));
	const showGuestplan = computed(() => pageSlug.value === 'restaurant');

	const removeGuestplanArtifacts = () => {
		const iframes = document.querySelectorAll('iframe[src*="guestplan."]');
		iframes.forEach((el) => el.remove());

		const widgets = document.querySelectorAll(
			'[id*="guestplan"], [id*="gstpln"], [class*="guestplan"], [class*="gstpln"]',
		);
		widgets.forEach((el) => el.remove());

		const scripts = document.querySelectorAll('script[src*="cdn.guestplan.com/widget.js"]');
		scripts.forEach((el) => el.remove());
	};

	const destroyGuestplan = () => {
		if (false) {
			return;
		}

		removeGuestplanArtifacts();

		if (window._gstpln) {
			delete window._gstpln;
		}
	};

	const mountGuestplan = () => {
		if (false || !showGuestplan.value) {
			return;
		}

		if (document.querySelector('script[src*="cdn.guestplan.com/widget.js"]')) {
			return;
		}

		window._gstpln = {};
		window._gstpln.accessKey = 'afd0032af3d2216aa3981993eaac5cc13f67a4ef';

		const normalizedLocale = locale.value.split(/[-_]/)[0].toLowerCase();
		window._gstpln.locale = normalizedLocale;

		const script = document.createElement('script');
		script.async = true;
		script.src = 'https://cdn.guestplan.com/widget.js';
		document.body.appendChild(script);
	};

	const refreshGuestplan = async () => {
		destroyGuestplan();

		if (!showGuestplan.value) {
			return;
		}

		await nextTick();
		mountGuestplan();
	};

	onMounted(() => {
		mountGuestplan();

		watch(
			[() => route.path, () => locale.value],
			async () => {
				await refreshGuestplan();
			},
			{ immediate: false },
		);
	});

	onUnmounted(() => {
		destroyGuestplan();
	});

	return {
		showGuestplan,
	};
};
